/*
 * Header "Shop by Parts" dropdown (desktop only).
 * Delegated, idempotent (guarded via window.__headerCategoriesInit) so it
 * survives section re-renders in the theme editor.
 */
(function () {
  if (window.__headerCategoriesInit) return;
  window.__headerCategoriesInit = true;

  var OPEN_CLASS = 'header-categories__menu--open';

  function getParts(btn) {
    var root = btn.closest('[data-header-categories]');
    if (!root) return null;
    return { root: root, menu: root.querySelector('.header-categories__menu') };
  }

  function closeAll(except) {
    document.querySelectorAll('[data-header-categories]').forEach(function (root) {
      var btn = root.querySelector('.header-categories__btn');
      var menu = root.querySelector('.header-categories__menu');
      if (!btn || !menu || root === except) return;
      btn.setAttribute('aria-expanded', 'false');
      menu.classList.remove(OPEN_CLASS);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.header-categories__btn');

    if (btn) {
      event.preventDefault();
      var parts = getParts(btn);
      if (!parts) return;
      var isOpen = parts.menu.classList.contains(OPEN_CLASS);
      closeAll(isOpen ? null : parts.root);
      btn.setAttribute('aria-expanded', String(!isOpen));
      parts.menu.classList.toggle(OPEN_CLASS, !isOpen);
      return;
    }

    // Click outside any dropdown closes them.
    if (!event.target.closest('[data-header-categories]')) {
      closeAll(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
